// Data aane tak ka shimmer loader — asli page jaisa hi layout.
import React from "react";
import styles from "./PounceAgentSkeleton.module.css";
import footerStyles from "../PounceFooterNav/PounceFooterNav.module.css";

const PounceAgentSkeleton = () => (
  <>
    {/* Skeleton Agent Card */}
    <div className={styles.skeletonAgentCard}>
      <div className={`${styles.skeletonAvatar} ${styles.shimmer}`} />
      <div className={styles.skeletonInfo}>
        <div className={`${styles.shimmer} ${styles.skeletonName}`} />
        <div className={`${styles.shimmer} ${styles.skeletonBusiness}`} />
        <div className={`${styles.shimmer} ${styles.skeletonNumber}`} />
      </div>
    </div>

    {/* Skeleton Actions */}
    <div className={styles.skeletonActions}>
      <div className={`${styles.skeletonActionBtn} ${styles.shimmer}`} />
      <div className={`${styles.skeletonActionBtn} ${styles.shimmer}`} />
      <div className={`${styles.skeletonActionBtn} ${styles.shimmer}`} />
    </div>

    {/* Skeleton Analytics Title */}
    <div className={`${styles.shimmer} ${styles.skeletonTitle}`} />

    {/* Skeleton 4 Tiles */}
    <div className={styles.skeletonTiles}>
      <div className={`${styles.skeletonTile} ${styles.shimmer}`} />
      <div className={`${styles.skeletonTile} ${styles.shimmer}`} />
      <div className={`${styles.skeletonTile} ${styles.shimmer}`} />
      <div className={`${styles.skeletonTile} ${styles.shimmer}`} />
    </div>

    {/* Skeleton Chart Card */}
    <div className={styles.skeletonChartCard}>
      <div className={styles.skeletonChartHead}>
        <div className={`${styles.shimmer} ${styles.skeletonChartTitle}`} />
        <div className={`${styles.shimmer} ${styles.skeletonChartMeta}`} />
      </div>
      <div className={`${styles.skeletonChartWave} ${styles.shimmer}`} />
    </div>

    {/* Skeleton Activity Card */}
    <div className={styles.skeletonActivityCard}>
      <div className={`${styles.shimmer} ${styles.skeletonActivityTitle}`} />
      <div className={styles.skeletonActivityRow}>
        <div className={`${styles.shimmer} ${styles.skeletonCheck}`} />
        <div className={`${styles.shimmer} ${styles.skeletonActivityText}`} />
        <div className={`${styles.shimmer} ${styles.skeletonActivityTime}`} />
      </div>
      <div className={styles.skeletonActivityRow}>
        <div className={`${styles.shimmer} ${styles.skeletonCheck}`} />
        <div className={`${styles.shimmer} ${styles.skeletonActivityText}`} />
        <div className={`${styles.shimmer} ${styles.skeletonActivityTime}`} />
      </div>
    </div>

    {/* Skeleton Pounce Footer */}
    <footer className={footerStyles.pounceFooter}>
      <div className={`${styles.shimmer} ${styles.skeletonFooterItem}`} />
      <div className={`${styles.shimmer} ${styles.skeletonFooterItem}`} />
      <div className={`${styles.shimmer} ${styles.skeletonFooterItem}`} />
      <div className={`${styles.shimmer} ${styles.skeletonFooterItem}`} />
    </footer>
  </>
);

export default PounceAgentSkeleton;
